import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Refresh({ color = 'icon.arrowBlue', fill='none', ...props }) {
  return (
    <IconBase viewBox='0 0 18 18' {...props}>
      <Path
        d='M16.4895 2.60547V5.17702H13.918H16.4895'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M16.0267 5.17422C14.6702 2.688 12.0329 1 9 1C4.58133 1 1 4.58222 1 9C1 13.4178
        4.58133 17 9 17C13.4187 17 17 13.4178 17 9'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
    </IconBase>
  )
}

Refresh.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default Refresh
